export type MixerQrKind = "person" | "mission" | "event_entry" | "host_proof";

export type MixerQrRoute = {
  kind: MixerQrKind;
  url: URL;
  destination: string;
};

const PRODUCTION_HOST = "mixer.appsorder.com";

export function classifyMixerQr(rawValue: string, currentOrigin: string): MixerQrRoute | null {
  let url: URL;
  try {
    url = new URL(rawValue, currentOrigin);
  } catch {
    return null;
  }

  const trustedProductionUrl = url.protocol === "https:" && url.hostname === PRODUCTION_HOST;
  if (url.origin !== currentOrigin && !trustedProductionUrl) return null;

  let kind: MixerQrKind | null = null;
  if (/^\/c\/[^/]+\/?$/.test(url.pathname)) {
    kind = "person";
  } else if (/^\/join\/[^/]+\/?$/.test(url.pathname)) {
    kind = "event_entry";
  } else if (/^\/s\/[^/]+\/[^/]+\/?$/.test(url.pathname)) {
    const verificationCode = new URLSearchParams(url.hash.replace(/^#/, "")).get("verify") || "";
    kind = /^\d{6}$/.test(verificationCode) ? "host_proof" : "mission";
  }

  if (!kind) return null;
  return {
    kind,
    url,
    destination: url.origin === currentOrigin ? `${url.pathname}${url.search}${url.hash}` : url.toString(),
  };
}
